
import RandomString from '../RandomString';

export default class KioskId {

  public static generateRandomId(): KioskId {
    return new KioskId('K' + RandomString.generateUpperCase(6));
  }

  private readonly id: string;

  constructor(id: string) {
    if ( !!id && id.match(/^K[0-9A-Z]{4,9}$/) ) {
      this.id = id;
    }
    else {
      throw new Error(`Invalid Kiosk ID ${id}.`);
    }
  }

  public getId(): string {
    return this.id;
  }

  public toString(): string {
    return this.id;
  }

}
